module.exports = __webpack_public_path__ + "static/media/text-image.6bb2428d.svg";